import * as React from "react";

function PrivacyPolicySr() {
  return (
    <div>
      <section className="content">
        {/* <h2>OUR DATA PROTECTION POLICY</h2> */}
        {/* <hr /> */}
        <h3>Pravila o privatnosti</h3>
        <p>
          Zaštitu vaših ličnih podataka shvatamo veoma ozbiljno. Tretiramo vaše
          lične podatke poverljivo i u skladu sa zakonskim propisima o zaštiti
          podataka, kao i ovu izjavu o privatnosti podataka. Lični podaci se
          prikupljaju i obrađuju samo na ovoj veb stranici u meri koja je
          neophodna. Sledeća izjava vam daje pregled na koji način obezbeđujemo
          ovu zaštitu i kakva je vrsta podataka prikupljena za koju svrhu.
        </p>
        <hr />
        <h3>Naziv i adresa kontrolora</h3>
        <p>Rukovalac prema zakonu o zaštiti podataka je:</p>
        <p>
          Arbonia AG <br /> Amriswilerstrasse 50 <br /> 9320 Arbon <br />{" "}
          Švajcarska
        </p>
        <p>
          T +41 71 447 41 41 <br /> holding@arbonia.com
        </p>
        <hr />
        <h3>1. Vaša prava</h3>
        <p>
          Kada koristite ovaj veb-sajt, prikupljaju se različiti lični podaci.
          Lični podaci su podaci koji se mogu koristiti za vašu ličnu
          identifikaciju.{" "}
        </p>
        <p>
          U svakom trenutku imate pravo, u okviru važećih zakonskih odredbi, da
          dobijete informacije o svojim sačuvanim ličnim podacima, njihovom
          poreklu, kao i o primaocima i svrsi obrade podataka. Ako postoje
          zakonski preduslovi, imate pravo na ispravku ili brisanje svojih
          ličnih podataka, ograničenje njihove obrade, pravo na prigovor protiv
          obrade, kao i pravo na prenos podataka.
        </p>
        <p>
          Ako ste dali svoj pristanak za obradu vaših ličnih podataka od strane
          nas, imate pravo povući saglasnost u bilo koje vreme. Zakonitost
          obrade vaših ličnih podataka pre povlačenja saglasnosti neće biti
          pogođena povlačenjem. Dalja obrada podataka na drugoj pravnoj osnovi,
          kao što je ispunjenje zakonskih obaveza, ostaje nepromenjena ovim
          povodom.
        </p>
        <p>
          Ako smatrate da obrada vaših ličnih podataka od strane nas krši važeće
          zakone o zaštiti podataka, imate pravo da podnesete žalbu nadležnim
          organima.{" "}
        </p>
        <hr />
        <h3>2. Prikupljanje i obrada ličnih podataka</h3>
        <h5>a) Prilikom posete naše veb stranice</h5>
        <p>
          Kada posetite naš veb-sajt, obrađujemo podatke koje vaš pregledač
          automatski šalje nama. Podaci obuhvataju vašu IP adresu, vreme zahteva
          servera, tip i verziju pregledača, operativni sistem koji se koristi,
          URL referera, ime hosta računara koji pristupa. Lične podatke o
          korišćenju našeg veb-sajta obrađujemo samo ako je to neophodno kako
          bismo korisniku omogućili korišćenje usluge.
        </p>
        <p>
          Prikupljanje i obrada ovih podataka vrši se iz internih statističkih
          razloga. Osnova za obradu podataka je izvršenje ugovora ili
          predugovornih mera. Dalja osnova za obradu podataka je naš opravdani
          interes da obradimo podatke kako bismo obezbedili stabilnost i
          sigurnost veb-sajta.
        </p>
        <p>
          Ponekad koristimo i kolačiće (cookies) u te svrhe. Kolačići su mali
          tekstualni fajlovi koji se čuvaju na vašem računaru i koje vaš
          pregledač sačuva. Koriste se kako bi našu ponudu učinili korisnijom,
          efikasnijom i sigurnijom. Većina kolačića koje koristimo su tzv.
          "sesijski kolačići" i automatski se brišu na kraju vaše sesije.
          Kolačići ne oštećuju vaš računar i ne sadrže viruse. Imate opciju
          deaktiviranja ove funkcije u vašem pregledaču ili prilagođavanja
          postavki, tako da možete odabrati pojedinačno da li želite prihvatiti
          kolačić ili ne. U tom slučaju, upotrebljivost našeg veb-sajta može,
          međutim, biti ograničena. Kolačići koji su neophodni za izvođenje
          elektronskog komunikacionog postupka ili za pružanje određenih
          funkcija (npr. funkcija korpe za kupovinu) se čuvaju na osnovu našeg
          opravdanog interesa za čuvanje kolačića kako bismo obezbedili naše
          usluge na optimalan i tehnički besprekoran način.{" "}
        </p>

        <h5>b) Kada koristite kontakt obrazac</h5>
        <p>
          Ako nam šaljete zahteve, vaši podaci u obrascu zahteva, kao i bilo
          koji kontakt podaci koje pružite, biće sačuvani od strane nas u svrhu
          obrade vašeg zahteva i eventualnih dodatnih pitanja. Podatke ne
          prenosimo trećim stranama bez vašeg pristanka.
        </p>
        <p>
          Obrada vaših podataka vrši se na osnovu vaše saglasnosti. Možete
          povući ovu saglasnost u bilo koje vreme. Da biste to učinili, dovoljno
          je poslati neformalnu poruku putem e-pošte. Zakonitost postupaka
          obrade podataka koje smo preduzeli pre povlačenja saglasnosti ostaje
          nepromenjena povlačenjem.
        </p>
        <p>
          Vaši podaci ostaju kod nas dok ne zatražite da ih obrišemo, povučete
          saglasnost za čuvanje podataka ili ako svrha čuvanja podataka više ne
          postoji (npr. nakon obrade vašeg zahteva). Zakonski rokovi čuvanja
          podataka ostaju nepromenjeni time.
        </p>
        <h5>c) Obrada podataka u postupcima prijave</h5>
        <p>
          Sakupljamo i obrađujemo lične podatke kandidata u svrhu obrade
          postupka prijave. Ako se sa kandidatom zaključi ugovor o zaposlenju,
          preneseni podaci se čuvaju u svrhu upravljanja radnim odnosom uz
          poštovanje pravnih odredbi.{" "}
        </p>
        <p>
          Ako se ne zaključi ugovor o zaposlenju s kandidatom, dokumenti prijave
          se brišu šest meseci nakon obaveštenja o odbijanju, pod uslovom da
          brisanje ne kosi s bilo kojim drugim opravdanim interesima kontrolora
          podataka.{" "}
        </p>
        <p>
          Obrada ličnih podataka u svrhu navedenu gore vrši se na osnovu
          saglasnosti ili na osnovu opravdanog interesa koji se suprotstavlja
          brisanju.
        </p>
        <p>
          Možemo sarađivati sa drugim kompanijama unutar Arbonia Grupe i drugim
          procesorima trećih strana (npr. pružaoci IT usluga). Svi transferi
          ličnih podataka obavljaju se u skladu sa važećim zakonima o zaštiti
          podataka, a postoje odgovarajuće ugovorne, tehničke i organizacione
          mere.
        </p>
        <p>
          <b>Beleške o rexx-u</b>
          <br />
          Koristimo usluge rexx systems GmbH, sa sedištem na adresi Süderstrasse
          75–79, 20097 Hamburg, Nemačka ("rexx"). Švajcarska podružnica, rexx
          systems Schweiz AG, registrovana je na adresi Sparrenbergstrasse 5,
          8103 Zurich. Nakon unosa i prenosa ličnih podataka u postupku prijave,
          vaši podaci mogu, putem direktnog enkriptovanog transfera, stići do
          servera rexx-a, koji podatke čuva, jednom enkriptovane, na svom
          serveru u računarskom centru Host Europe GmbH (Cologne). Ukoliko je to
          slučaj, svi podaci se enkriptuju putem SSL-a. Ako se prijavljujete sa
          korisničkim podacima nakon registracije, takođe se koristi SSL
          enkripcija.
        </p>
        <p>
          Prenos ličnih podataka vrši se u skladu sa važećim zakonima o zaštiti
          podataka, a postoje odgovarajuće ugovorne, tehničke i organizacione
          mere. I kontrolor i pružalac usluga primenjuju tehničke i
          organizacione sigurnosne mere kako bi zaštitili prikupljene podatke od
          slučajne ili namernje manipulacije, gubitka, uništenja ili pristupa
          neovlašćenih osoba. Naše sigurnosne mere se stalno unapređuju u skladu
          sa najnovijim tehnološkim razvojem.
        </p>
        <h5>
          d) Obrada podataka u svrhu slanja newslettera i promocija putem pošte
        </h5>
        <p>
          Ako se pretplatite na jedan od ponuđenih newslettera ili promotivnih
          materijala na veb-sajtu, podaci koje ste pružili prilikom pretplate
          koristiće se za slanje newslettera, pod uslovom da niste saglasni sa
          daljim korišćenjem. Saglasni ste da nam je dozvoljeno preneti ove
          lične podatke drugim kompanijama unutar Arbonia Grupe, i takođe, da
          druge kompanije unutar Arbonia Grupe mogu koristiti ove podatke u istu
          svrhu i slati vam newslettere o celokupnoj ponudi Arbonia Grupe. Vaši
          lični podaci neće biti prosleđeni trećim stranama van kompanija
          Arbonia Grupe.
        </p>
        <p>
          Ako se pretplatite na e-mail newsletter, za šta je potrebno uneti
          lične podatke, dobićete potvrdu putem e-maila poslatu na e-mail adresu
          koju ste pružili. Registracioni proces se završava tek nakon klika na
          link u ovom e-mailu. Obrada se vrši isključivo na osnovu vaše
          saglasnosti. Možete povući izdatu saglasnost za čuvanje podataka,
          e-mail adrese i njenog korišćenja za slanje newslettera u bilo koje
          vreme putem opcije odjave u newsletteru. Zakonitost već sprovedenih
          postupaka obrade podataka pre povlačenja ostaje nepromenjena
          povlačenjem saglasnosti.
        </p>
        <p>
          Podaci koje ste pružili prilikom registracije za newsletter čuvaju se
          kod nas sve do vašeg uklanjanja sa liste distribucije newslettera i
          odjave sa istog. Podaci koji su sačuvani kod nas u druge svrhe ili na
          osnovu drugih saglasnosti (npr. e-mail adrese za drugi newsletter ili
          za druge funkcije na veb-sajtu) ostaju nepromenjeni ovim povodom.
        </p>
        <p>
          Možemo sarađivati sa drugim kompanijama unutar Arbonia Grupe i drugim
          procesorima trećih strana (npr. pružaoci IT usluga). Svi transferi
          ličnih podataka obavljaju se u skladu sa važećim zakonima o zaštiti
          podataka, a postoje odgovarajuće ugovorne, tehničke i organizacione
          mere.
        </p>
        <hr />
        <h3>
          3. Prenos ličnih podataka i obrada podataka od strane trećih strana
        </h3>
        <p>
          Uopšteno, koristimo lične podatke samo u interne poslovne svrhe. U tu
          svrhu imamo dozvolu da prenesemo lične podatke drugim kompanijama
          unutar Arbonia Grupe, a druge kompanije unutar Arbonia Grupe takođe
          mogu koristiti ove podatke u istu svrhu. Vaši lični podaci se ne
          prenose van kompanija Arbonia Grupe, osim ako je to neophodno za
          izvršenje ugovora, zakonski dozvoljeno ili ste dali saglasnost za to.{" "}
        </p>
        <p>
          Međutim, možemo zaključiti ugovore s drugim kompanijama ili osobama
          ("procesorima") radi prenosa obavljanja određenih zadataka u naše ime.
          U tu svrhu može biti potrebno da dodelimo pristup ličnim podacima
          procesoru. Naši procesori su obavezni održavati poverljivost o
          prenetim ličnim podacima i nisu ovlašćeni koristiti informacije u
          druge svrhe osim onih koje su specificirane od strane nas.{" "}
        </p>
        <p>
          Svaki prenos ličnih podataka obavlja se u skladu sa važećim zakonima o
          zaštiti podataka, i mi obezbeđujemo da postoje odgovarajuće ugovorne,
          tehničke i organizacione mere.
        </p>
        <hr />
        <h3>4. Usluge ili sadržaj trećih strana na našoj veb stranici</h3>
        <p>
          Na našem veb-sajtu nudimo usluge i/ili sadržaj trećih strana. Ako
          koristite ove usluge trećih strana ili ako se prikazuje sadržaj trećih
          strana, podaci o komunikaciji se razmenjuju između vas i odgovarajućeg
          pružaoca iz tehničkih razloga. Mi ne kontrolišemo ni veb-sajtove ni
          prakse zaštite podataka trećih strana koje upravljaju tim
          veb-sajtovima. Ova izjava o zaštiti podataka ne odnosi se na povezane
          stranice ili usluge trećih strana.
        </p>
        <p>
          Odgovarajući pružalac usluga ili sadržaja takođe može prikupljati
          dodatne podatke i obrađivati ih u druge svrhe. Prema našem najboljem
          saznanju, konfigurirali smo usluge i sadržaj pružalaca koji obrađuju
          podatke u svoje svrhe, tako da je komunikacija blokirana za druge
          svrhe osim komunikacije ili prikazivanja usluga ili sadržaja na našem
          veb-sajtu, ili se lični podaci prikupljaju samo ako odlučite koristiti
          određenu uslugu. Međutim, kako nemamo kontrolu nad podacima koji se
          prikupljaju i obrađuju od strane trećih strana, nismo u mogućnosti
          pružiti obavezujuće informacije o opsegu i svrsi obrade vaših podataka
          od strane odgovarajućeg pružaoca trećih strana.
        </p>
        <h5>a) Veb stranice</h5>
        <p>
          Za vašu informaciju, na našem veb-sajtu se mogu pronaći linkovi koji
          vode ka stranicama trećih strana. Kako se radi o veb-sajtovima drugih
          pružalaca, nemamo uticaj na njihov sadržaj; odgovoran je isključivo
          odgovarajući pružalac. Na povezanim stranicama trećih strana, ova
          izjava o zaštiti podataka se ne primenjuje.
        </p>
        <h5>b) Alati</h5>
        <p>
          Naš veb-sajt koristi funkcije Google Maps i YouTube kako bi se
          povećala funkcionalnost našeg veb-sajta.{" "}
        </p>
        <p>
          <b>Beleške o Google mapama</b>
          <br />
          Naš veb-sajt koristi funkcije servisa za mape Google Maps. Za
          korišćenje funkcija Google Maps, neophodno je sačuvati vašu IP adresu.
          Ove informacije mogu biti prenesene na Google server u Sjedinjenim
          Američkim Državama i tamo sačuvane. Nemamo uticaja na prenos ovih
          podataka.
        </p>
        <p>
          Google Maps se koristi u cilju prikazivanja naših online ponuda na
          privlačan način i olakšavanja pronalaženja naše lokacije koja je
          navedena na veb-sajtu. Ovo predstavlja opravdan interes.
        </p>
        <p>
          Ova funkcija pruža se od strane Google Inc., 1600 Amphitheatre
          Parkway, Mountain View, CA 94043, Sjedinjene Američke Države. Više
          informacija o postupanju s korisničkim podacima od strane Google-a
          možete pronaći u izjavi o zaštiti podataka koja pripada Google-u.
        </p>
        <p>
          <b>Beleške o YouTube-u</b>
          <br />
          Naš veb-sajt koristi funkcije YouTube-a, koji je u vlasništvu
          Google-a. Ako posetite naš veb-sajt opremljen YouTube dodatkom,
          uspostaviće se veza sa serverima YouTube-a. Ovo obaveštava YouTube
          server o tome koje od naših stranica ste posetili. Ako ste prijavljeni
          na svoj YouTube nalog, dozvoljavate YouTube-u da direktno dodeljuje
          vaše ponašanje pri surfovanju vašem ličnom profilu. To možete sprečiti
          odjavljivanjem sa svog YouTube naloga. Želimo napomenuti da nemamo
          saznanja o sadržaju prenetih podataka i njihovoj upotrebi od strane
          YouTube-a.
        </p>
        <p>
          YouTube se koristi u cilju prikazivanja naših online ponuda na
          privlačan način. Ovo predstavlja opravdan interes.
        </p>
        <p>
          Dodatak upravlja YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066,
          Sjedinjene Američke Države. Dodatne informacije o postupanju s
          korisničkim podacima od strane YouTube-a možete pronaći u izjavi o
          zaštiti podataka koja pripada YouTube-u.
        </p>
        <hr />
        <h3>5. Brisanje ličnih podataka</h3>
        <p>
          Pod uslovom da nismo naveli posebne rokove čuvanja u ovoj izjavi o
          zaštiti podataka, primenjuju se sledeća opšta pravila:
        </p>
        <p>
          Opšte pravilo je da se vaši podaci brišu čim više nisu potrebni za
          predviđenu svrhu, ukoliko povučete svoj pristanak ili ukoliko povučete
          korišćenje na osnovu opravdanog interesa. Podaci se čuvaju nakon
          isteka ovog perioda samo ukoliko je to potrebno zbog zakonskog propisa
          kojem smo podložni (npr. poreski i trgovinski propisi) ili ako su
          podaci neophodni za utvrđivanje, ostvarivanje ili odbranu od pravnih
          zahteva.
        </p>
        <hr />
        <h3>6. Sigurnost i bezbednost</h3>
        <p>
          Sve informacije koje nam šaljete čuvaju se na serverima unutar
          Evropske unije, EEC i Švajcarske. Prilikom čuvanja ovih podataka,
          posebnu pažnju posvećujemo obezbeđivanju odgovarajućeg nivoa zaštite
          podataka u odgovarajućoj zemlji.
        </p>
        <p>
          Preduzimamo odgovarajuće tehničke i organizacione sigurnosne mere kako
          bismo zaštitili vaše podatke od slučajne ili namerne manipulacije,
          delimičnog ili potpunog gubitka, uništenja ili neovlašćenog pristupa
          od strane trećih strana. Naše sigurnosne mere se kontinuirano
          unapređuju i prilagođavaju najnovijim tehnološkim razvojima.
        </p>
        <p>
          Međutim, želimo napomenuti da prenos podataka putem interneta (npr. u
          e-mail komunikaciji) može imati sigurnosne propuste. Potpuna zaštita
          podataka od pristupa trećih strana nije moguća.
        </p>
        <hr />
        <h3>7. Promene u izjavi o zaštiti podataka</h3>
        <p>
          Ova izjava o zaštiti podataka može biti predmet izmena, na primer zbog
          promena u zakonu ili načinu obrade podataka. Stoga vas molimo da
          redovno čitate ovu stranicu.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicySr;
